/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Import_Progress_ChipInputs */

const cs_import_progress_chip = /** @type {(inputs: Import_Progress_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import ${i?.percent}%`)
};

const en_import_progress_chip = /** @type {(inputs: Import_Progress_ChipInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Import ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Import {percent}%" |
*
* @param {Import_Progress_ChipInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_progress_chip = /** @type {((inputs: Import_Progress_ChipInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Progress_ChipInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_progress_chip(inputs)
	return cs_import_progress_chip(inputs)
});